import { search } from "../api/content";
import { SearchExperience } from "../components/search/SearchExperience";

/**
 * "What's New" — the newest additions to the site across every content type
 * (posts, videos, photos, links), newest first. A period-appropriate riff on
 * the old "What's New" page, reusing the same faceted feed as Search.
 */
export function NewsPage() {
  return (
    <div className="page">
      <div className="container">
        <header className="page__head">
          <p className="eyebrow">What&rsquo;s New</p>
          <h1 className="page__title">What&rsquo;s New</h1>
          <p className="page__intro">
            The latest additions to the site &mdash; new posts, videos, photos,
            and links, newest first. Check back often!
          </p>
        </header>

        <SearchExperience
          fetcher={search}
          placeholder="Search the latest…"
          emptyLabel="Nothing new yet — check back soon."
        />
      </div>
    </div>
  );
}
